import React from 'react';
import cx from '../../utils/cx.js';
import EmoticonsActionCreators from '../../actions/EmoticonsActionCreators';
import emojione from 'emojione';

const categoryIcons = {
  1: ':grinning:',
  2: ':hearts:',
  3: ':tulip:',
  4: ':rabbit2:',
  5: ':cherries:',
  6: ':basketball:',
  7: ':sun_with_face:',
  8: ':thumbsup:',
  9: ':eyeglasses:',
  10: ':red_car:',
};

class EmoticonsTabs extends React.Component {
  render() {
    const tabs = [];
    for (let i = 1; i <= 10; i++) {
      tabs.push(<div
        className={cx([
				'emoticons-tab',
				['is-active', this.props.pageId == i]])}
        onClick={EmoticonsActionCreators.loadEmoticonsPage.bind(null, i)}
        key={i}
      >
        <div
          className="emoticons-tabIcon"
          dangerouslySetInnerHTML={{ __html: emojione.shortnameToImage(categoryIcons[i]) }}
        />
                </div>);
    }
    return (
      <div className="emoticons-tabs">
        {tabs}
      </div>
    );
  }
}

module.exports = EmoticonsTabs;
